import React from 'react';
import SiteFooter from '../components/SiteFooter';

export default function HowItWorks() {
  return (
    <div style={{background:'#F6F4EF', minHeight:'100vh'}}>
      <div style={{maxWidth:900, margin:'0 auto', padding:'24px 16px'}}>
        <h1>Як це працює</h1>
        <ol style={{lineHeight:1.7}}>
          <li><b>Приносьте книгу</b> у партнерську кав’ярню — бариста додає її в систему.</li>
          <li><b>Отримуйте монети</b> — сума розраховується від кількості сторінок та року видання.</li>
          <li><b>Беріть інші книги</b> — читайте в зручному для вас темпі</li>
          <li><b>Знову приносьте книгу</b> — отримуйте монети та вибирайте нову</li>
        </ol>
        <p style={{color:'#374151'}}>
          Мета Книгообігу — зробити обмін книжками простим і локальним: книги поруч, у ваших улюблених кавʼярнях.
        </p>
      </div>
      <SiteFooter />
    </div>
  );
}

